<!--&lt;!&ndash; Хедер &ndash;&gt;-->
<!--<header>-->
<!--  <div class="container-small">-->
<!--    <div class="header">-->
<!--      <div class="header__logo">-->
<!--        <img src="assets/images/removia-logo-white.svg" alt="logo">-->
<!--      </div>-->
<!--      <div class="header__btn">-->
<!--        <a href="/pricing" class="desktop button default">-->
<!--          Get protected-->
<!--        </a>-->
<!--        <a href="#plan" id="scroll-down-mobile" class="mobile button default">-->
<!--          Plan-->
<!--        </a>-->
<!--        <a href="/dashboard" target="_blank" class="button grad">-->
<!--          Log in-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</header>-->

<!--&lt;!&ndash; Секції &ndash;&gt;-->
<!--<main>-->
<!--  <section class="banner" id="banner">-->
<!--    <div class="container-small">-->
<!--      <div class="banner__wrapper">-->
<!--        <div class="banner__info">-->
<!--          <div class="banner__info&#45;&#45;title">-->
<!--            Your data <span>belongs to you</span>-->
<!--          </div>-->
<!--          <div class="banner__info&#45;&#45;desc">-->
<!--            Your private life doesn’t need to be online. We’ll help you <span>reclaim</span> your digital freedom and-->
<!--            make your sensitive data vanish from the internet.-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="banner__img">-->
<!--          <img src="assets/images/banner.svg" alt="banner">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->

<!--  <section class="swiper" id="swiper">-->
<!--    <div class="swiper__thumbs">-->
<!--      <div class="swiper-container">-->
<!--        <div class="swiper-wrapper">-->
<!--          <div class="swiper-slide">-->
<!--            <div class="swiper__thumbs__item">-->
<!--              <img src="assets/images/swiper-01.png" alt="slider-img-01" class="s-img-switch"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="swiper-slide">-->
<!--            <div class="swiper__thumbs__item">-->
<!--              <img src="assets/images/swiper-03.jpg" alt="slider-img-01" class="s-img-switch"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="swiper-slide">-->
<!--            <div class="swiper__thumbs__item">-->
<!--              <img src="assets/images/swiper-02.jpg" alt="slider-img-01" class="s-img-switch"/>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="swiper__info">-->
<!--      <div class="swiper-container">-->
<!--        <div class="swiper-wrapper">-->
<!--          <div class="swiper-slide">-->
<!--            <div class="swiper__info__item">-->
<!--              <div class="swiper__info__item&#45;&#45;title">-->
<!--                What does the internet <span>know about you?</span>-->
<!--              </div>-->
<!--              <div class="swiper__info__item&#45;&#45;desc">-->
<!--                <p>You’re being watched online, even if you’ve never signed up for anything.</p>-->
<!--                <p>Your name, contact details, addresses, family connections, shopping habits, even photos – are often-->
<!--                  gathered by data brokers without your knowledge.</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="swiper-slide">-->
<!--            <div class="swiper__info__item">-->
<!--              <div class="swiper__info__item&#45;&#45;title">-->
<!--                Who are <span>data brokers?</span>-->
<!--              </div>-->
<!--              <div class="swiper__info__item&#45;&#45;desc">-->
<!--                <p>You’ve never heard of them - but they know everything about you.</p>-->
<!--                <p>Data brokers collect your personal information from websites, apps, public records, and even your-->
<!--                  online shopping habits.</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="swiper-slide">-->
<!--            <div class="swiper__info__item">-->
<!--              <div class="swiper__info__item&#45;&#45;title">-->
<!--                What happens to <span>your data?</span>-->
<!--              </div>-->
<!--              <div class="swiper__info__item&#45;&#45;desc">-->
<!--                <p>This information, often gathered quietly, packaged and sold by data brokers to advertisers, marketers-->
<!--                  and even unknown third parties- without your consent.</p>-->
<!--                <p>We find your data – and make it disappear.</p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="swiper-pagination"></div>-->
<!--  </section>-->

<!--  <section class="privacy" id="privacy">-->
<!--    <div class="container">-->
<!--      <div class="privacy__wrapper">-->
<!--        <div class="privacy__title">-->
<!--          Privacy Starts with Knowing <span>What’s at Stake</span>-->
<!--        </div>-->
<!--        <div class="privacy__list">-->
<!--          <div class="privacy__list&#45;&#45;item">-->
<!--            <div class="privacy__list&#45;&#45;inner">-->
<!--              <div class="privacy__list&#45;&#45;title">-->
<!--                Spam & Unwanted Messages-->
<!--              </div>-->
<!--              <div class="privacy__list&#45;&#45;desc">-->
<!--                Public email and phone data may lead to more junk mail, robocalls, and unsolicited texts from marketers-->
<!--                and unknown sources.-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="privacy__list&#45;&#45;item">-->
<!--            <div class="privacy__list&#45;&#45;inner">-->
<!--              <div class="privacy__list&#45;&#45;title">-->
<!--                Unwanted Ads & Targeting-->
<!--              </div>-->
<!--              <div class="privacy__list&#45;&#45;desc">-->
<!--                Your online activity and purchase habits may be used to create detailed profiles and deliver-->
<!--                hyper-targeted ads.-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="privacy__list&#45;&#45;item">-->
<!--            <div class="privacy__list&#45;&#45;inner">-->
<!--              <div class="privacy__list&#45;&#45;title">-->
<!--                Small Leak Noticeable Over Time-->
<!--              </div>-->
<!--              <div class="privacy__list&#45;&#45;desc">-->
<!--                A few exposed details – like your name, location may be enough to piece together your identity. Over-->
<!--                time, this may increase your online vulnerability.-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->

<!--  <section class="stat" id="stat">-->
<!--    <div class="stat__wrapper">-->
<!--      <div class="stat__title">-->
<!--        Don’t be just another <span>statistics</span>-->
<!--      </div>-->
<!--      <div class="stat__info">-->
<!--        <div class="stat__main-img image">-->
<!--          <img src="assets/images/stat-01.svg" alt="main-img"/>-->
<!--        </div>-->
<!--        <div class="stat__left-top-img image">-->
<!--          <img src="assets/images/stat-02.svg" alt="left-top-img"/>-->
<!--        </div>-->
<!--        <div class="stat__right-top-img image">-->
<!--          <img src="assets/images/stat-03.svg" alt="right-top-img"/>-->
<!--        </div>-->
<!--        <div class="stat__left-bottom-img image">-->
<!--          <img src="assets/images/stat-04.svg" alt="left-bottom-img"/>-->
<!--        </div>-->
<!--        <div class="stat__right-bottom-img image">-->
<!--          <img src="assets/images/stat-05.svg" alt="right-bottom-img"/>-->
<!--        </div>-->
<!--        <div class="stat__left-top-info text">-->
<!--          <div class="stat__number right">5000</div>-->
<!--          <div class="stat__text right">data broker companies worldwide</div>-->
<!--          <a href="https://stratcomcoe.org/cuploads/pfiles/data_brokers_and_security_20-01-2020.pdf" target="_blank" class="right">read more</a>-->
<!--        </div>-->
<!--        <div class="stat__right-top-info text">-->
<!--          <div class="stat__number">96,8%</div>-->
<!--          <div class="stat__text">of people receive spam messages</div>-->
<!--          <a href="https://www.emailtooltester.com/en/blog/spam-statistics/" target="_blank">read more</a>-->
<!--        </div>-->
<!--        <div class="stat__left-bottom-info text">-->
<!--          <div class="stat__number right">$389</div>-->
<!--          <div class="stat__text right">billions is the value of the global data broker market</div>-->
<!--          <a href="https://www.globenewswire.com/news-release/2024/11/15/2981819/0/en/Data-Broker-Market-Forecasts-2024-2029-Increasing-Demand-for-Targeted-Marketing-Rising-Penetration-of-IoT-with-North-America-Projected-to-Lead-Growth.html?utm_source=chatgpt.com" target="_blank" class="right">read more</a>-->
<!--        </div>-->
<!--        <div class="stat__right-bottom-info text">-->
<!--          <div class="stat__number">33%</div>-->
<!--          <div class="stat__text">of US citizens have been victims of identity theft</div>-->
<!--          <a href="https://www.ic3.gov/AnnualReport/Reports/2021_IC3Report.pdf" target="_blank">read more</a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->

<!--  <section class="removed" id="removed">-->
<!--    <div class="container">-->
<!--      <div class="removed__wrapper">-->
<!--        <div class="removed__info">-->
<!--          <div class="removed__info&#45;&#45;title">-->
<!--            We contact data brokers to get <span>your personal info removed</span>-->
<!--          </div>-->
<!--          <div class="removed__info&#45;&#45;subtitle">-->
<!--            <p>Deleting your data manually can take hours – just to get started.</p>-->
<!--            <p>But that’s only the beginning.</p>-->
<!--            <p>Here’s why <span>doing it alone is often more work than it’s worth:</span></p>-->
<!--          </div>-->
<!--          <img src="assets/images/removed-icon.svg" class="removed__info&#45;&#45;icon" alt="title-icon">-->
<!--        </div>-->
<!--        <div class="removed__list">-->
<!--          <div class="removed__list&#45;&#45;item">-->
<!--            <div class="removed__list&#45;&#45;inner">-->
<!--              <img src="assets/images/removed-01.svg" class="removed__list&#45;&#45;icon" alt="icon">-->
<!--              <div class="removed__list&#45;&#45;title">-->
<!--                Time Commitment-->
<!--              </div>-->
<!--              <div class="removed__list&#45;&#45;manual">-->
<!--                <div class="removed__list&#45;&#45;manual&#45;&#45;title">-->
<!--                  <i class="icon ion-android-close"></i>-->
<!--                  Manual:-->
<!--                </div>-->
<!--                <div class="removed__list&#45;&#45;manual&#45;&#45;desc">-->
<!--                  Research each broker, fill out forms, follow complex steps.-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="removed__list&#45;&#45;service">-->
<!--                <div class="removed__list&#45;&#45;service&#45;&#45;title">-->
<!--                  <i class="icon ion-android-done"></i>-->
<!--                  Our Service:-->
<!--                </div>-->
<!--                <div class="removed__list&#45;&#45;service&#45;&#45;desc">-->
<!--                  We automate the process – just sign up once.-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="removed__list&#45;&#45;item">-->
<!--            <div class="removed__list&#45;&#45;inner">-->
<!--              <img src="assets/images/removed-02.svg" class="removed__list&#45;&#45;icon" alt="icon">-->
<!--              <div class="removed__list&#45;&#45;title">-->
<!--                Reappearance of Data-->
<!--              </div>-->
<!--              <div class="removed__list&#45;&#45;manual">-->
<!--                <div class="removed__list&#45;&#45;manual&#45;&#45;title">-->
<!--                  <i class="icon ion-android-close"></i>-->
<!--                  Manual:-->
<!--                </div>-->
<!--                <div class="removed__list&#45;&#45;manual&#45;&#45;desc">-->
<!--                  Many sites republish info – keep checking and resubmitting.-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="removed__list&#45;&#45;service">-->
<!--                <div class="removed__list&#45;&#45;service&#45;&#45;title">-->
<!--                  <i class="icon ion-android-done"></i>-->
<!--                  Our Service:-->
<!--                </div>-->
<!--                <div class="removed__list&#45;&#45;service&#45;&#45;desc">-->
<!--                  We monitor and re-request removals for you.-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="removed__list&#45;&#45;item">-->
<!--            <div class="removed__list&#45;&#45;inner">-->
<!--              <img src="assets/images/removed-03.svg" class="removed__list&#45;&#45;icon" alt="icon">-->
<!--              <div class="removed__list&#45;&#45;title">-->
<!--                Finding Data Brokers-->
<!--              </div>-->
<!--              <div class="removed__list&#45;&#45;manual">-->
<!--                <div class="removed__list&#45;&#45;manual&#45;&#45;title">-->
<!--                  <i class="icon ion-android-close"></i>-->
<!--                  Manual:-->
<!--                </div>-->
<!--                <div class="removed__list&#45;&#45;manual&#45;&#45;desc">-->
<!--                  There are thousands out there. Most people don’t know where to begin.-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="removed__list&#45;&#45;service">-->
<!--                <div class="removed__list&#45;&#45;service&#45;&#45;title">-->
<!--                  <i class="icon ion-android-done"></i>-->
<!--                  Our Service:-->
<!--                </div>-->
<!--                <div class="removed__list&#45;&#45;service&#45;&#45;desc">-->
<!--                  We scan across dozens of known data broker sites instantly.-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="removed__list&#45;&#45;item">-->
<!--            <div class="removed__list&#45;&#45;inner">-->
<!--              <img src="assets/images/removed-04.png" alt="icon">-->
<!--              <div class="removed__list&#45;&#45;title">-->
<!--                Peace and Confidence-->
<!--              </div>-->
<!--              <div class="removed__list&#45;&#45;manual">-->
<!--                <div class="removed__list&#45;&#45;manual&#45;&#45;title">-->
<!--                  <i class="icon ion-android-close"></i>-->
<!--                  Manual:-->
<!--                </div>-->
<!--                <div class="removed__list&#45;&#45;manual&#45;&#45;desc">-->
<!--                  Uncertainty about what’s still out there.-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="removed__list&#45;&#45;service">-->
<!--                <div class="removed__list&#45;&#45;service&#45;&#45;title">-->
<!--                  <i class="icon ion-android-done"></i>-->
<!--                  Our Service:-->
<!--                </div>-->
<!--                <div class="removed__list&#45;&#45;service&#45;&#45;desc">-->
<!--                  Set it and forget it – we’ll do the follow-up for you.-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->

<!--  <section class="streamline" id="streamline">-->
<!--    <div class="container-small">-->
<!--      <div class="streamline__wrapper">-->
<!--        <div class="streamline__title">-->
<!--          Skip the hassle – we’ve streamlined everything to make it effortless for you-->
<!--        </div>-->
<!--        <div class="streamline__list">-->
<!--          <img src="assets/images/streamline-curve.svg" class="streamline__list&#45;&#45;curve" alt="icon">-->
<!--          <div class="streamline__list&#45;&#45;item">-->
<!--            <div class="streamline__list&#45;&#45;inner">-->
<!--              <div class="streamline__list&#45;&#45;top">-->
<!--                <div class="streamline__list&#45;&#45;top&#45;&#45;info">-->
<!--                  <div class="streamline__list&#45;&#45;number">-->
<!--                    01-->
<!--                  </div>-->
<!--                  <div class="streamline__list&#45;&#45;title">-->
<!--                    Submit your info-->
<!--                  </div>-->
<!--                </div>-->
<!--                <img src="assets/images/streamline-01.svg" class="streamline__list&#45;&#45;icon" alt="icon">-->
<!--              </div>-->
<!--              <div class="streamline__list&#45;&#45;desc">-->
<!--                Enter your basic info – we'll handle the removals across search engines and data broker platforms.-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="streamline__list&#45;&#45;item">-->
<!--            <div class="streamline__list&#45;&#45;inner">-->
<!--              <div class="streamline__list&#45;&#45;top">-->
<!--                <div class="streamline__list&#45;&#45;top&#45;&#45;info">-->
<!--                  <div class="streamline__list&#45;&#45;number">-->
<!--                    02-->
<!--                  </div>-->
<!--                  <div class="streamline__list&#45;&#45;title">-->
<!--                    Scan & Detect-->
<!--                  </div>-->
<!--                </div>-->
<!--                <img src="assets/images/streamline-02.svg" class="streamline__list&#45;&#45;icon" alt="icon">-->
<!--              </div>-->
<!--              <div class="streamline__list&#45;&#45;desc">-->
<!--                We search dozens of known data broker sites to find where your personal information is publicly listed.-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="streamline__list&#45;&#45;item">-->
<!--            <div class="streamline__list&#45;&#45;inner">-->
<!--              <div class="streamline__list&#45;&#45;top">-->
<!--                <div class="streamline__list&#45;&#45;top&#45;&#45;info">-->
<!--                  <div class="streamline__list&#45;&#45;number">-->
<!--                    03-->
<!--                  </div>-->
<!--                  <div class="streamline__list&#45;&#45;title">-->
<!--                    Request Removals-->
<!--                  </div>-->
<!--                </div>-->
<!--                <img src="assets/images/streamline-03.svg" class="streamline__list&#45;&#45;icon" alt="icon">-->
<!--              </div>-->
<!--              <div class="streamline__list&#45;&#45;desc">-->
<!--                Our team prepares and submits removal requests on your behalf – no forms or legal language needed from-->
<!--                you.-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="streamline__list&#45;&#45;item">-->
<!--            <div class="streamline__list&#45;&#45;inner">-->
<!--              <div class="streamline__list&#45;&#45;top">-->
<!--                <div class="streamline__list&#45;&#45;top&#45;&#45;info">-->
<!--                  <div class="streamline__list&#45;&#45;number">-->
<!--                    04-->
<!--                  </div>-->
<!--                  <div class="streamline__list&#45;&#45;title">-->
<!--                    Monitor & Recheck-->
<!--                  </div>-->
<!--                </div>-->
<!--                <img src="assets/images/streamline-04.svg" class="streamline__list&#45;&#45;icon" alt="icon">-->
<!--              </div>-->
<!--              <div class="streamline__list&#45;&#45;desc">-->
<!--                We continuously monitor for reappearance and re-submit takedown requests as needed.-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->

<!--  <section class="track" id="track">-->
<!--    <div class="track__bg">-->
<!--      <img src="assets/images/track-01.jpg" class="s-img-switch" alt="track-01">-->
<!--    </div>-->
<!--    <img src="assets/images/dashboard_preview.png" class="track__img" alt="track-02">-->
<!--    <div class="container">-->
<!--      <div class="track__wrapper">-->
<!--        <div class="track__info">-->
<!--          <div class="track__title">-->
<!--            Track your data removal <span>in real time</span>-->
<!--          </div>-->
<!--          <div class="track__desc">-->
<!--            <p>Your personal dashboard keeps you informed every step of the way – showing live updates on which brokers-->
<!--              we've contacted, what’s still pending, and what’s been removed.</p>-->
<!--            <p>With a clean, easy-to-use layout, you’ll always know how your privacy is being protected.</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </section>-->
<!--</main>-->

<!--&lt;!&ndash; Футер &ndash;&gt;-->
<!--<footer>-->
<!--  <div class="container">-->
<!--    <div class="footer__wrapper">-->
<!--      <div class="footer__img">-->
<!--        <img src="assets/images/banner.svg" alt="banner">-->
<!--      </div>-->
<!--      <div class="footer__links">-->
<!--        <div class="footer__links__item">-->
<!--          <div class="footer__links__title">-->
<!--            Menu-->
<!--          </div>-->
<!--          <div class="footer__links__list">-->
<!--            <a href="/" target="_blank">Home</a>-->
<!--            <a href="/blog" target="_blank">Blog</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="footer__links__item">-->
<!--          <div class="footer__links__title">-->
<!--            Resources-->
<!--          </div>-->
<!--          <div class="footer__links__list">-->
<!--            <a href="#" target="_blank">Privacy Policy</a>-->
<!--            <a href="#" target="_blank">Terms of use</a>-->
<!--            <a href="#" target="_blank">Refund Policy</a>-->
<!--            <a href="#" target="_blank">EULA</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="footer__links__item">-->
<!--          <div class="footer__links__list" style="padding-top: 48px">-->
<!--            <a href="#" target="_blank">Cookie Policy</a>-->
<!--            <a href="#" target="_blank">GDPR Notice</a>-->
<!--            <a href="#" target="_blank">CCPA Notice</a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="footer__logo">-->
<!--        <img style="padding-bottom: 15px" src="assets/images/removia-logo-white.svg" alt="logo">-->
<!--        <br>-->
<!--        <div>-->
<!--          <div>-->
<!--            <span style="color: white; font-family: Manrope; font-weight: 800; font-size: 18px; line-height: 32px; letter-spacing: 0px; text-transform: uppercase;">-->
<!--              Contact us-->
<!--            </span>-->
<!--            <br>-->
<!--            <span style="color: white; font-family: Manrope; font-weight: 300; font-size: 18px; line-height: 22px; letter-spacing: -0.5px; text-decoration: underline; text-decoration-style: solid; text-decoration-offset: 0%; text-decoration-thickness: 0%; ">-->
<!--              <a style="color: white;" href="mailto:support@removia.io">support@removia.io</a>-->
<!--            </span>-->
<!--          </div>-->
<!--          <div>-->
<!--            <p  style="margin-top: 10px; padding-top: 10px; color:#FFFFFF; font-family: Manrope; font-weight: 300; font-size: 18px; line-height: 26px; letter-spacing: 0px;">-->
<!--              GotYourBack Technologies LTD-->
<!--              <br>-->
<!--              Ifigeneias 14, 3036 Limassol, Cyprus-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</footer>-->

<app-landing-header></app-landing-header>
<app-landing-main></app-landing-main>
<app-landing-footer></app-landing-footer>
